<template>
  <div class="product-of-the-day" v-if="this.banner && this.product">
    <div class="product-of-the-day__banner-wrap">
      <a :href="banner['link']" class="product-of-the-day__banner-link">
        <picture>
          <source :srcset="banner.image" media="(min-width: 1023px)" />
          <img
            :src="banner.image_mob"
            alt=""
          />
        </picture>
      </a>
    </div>
    <div class="product-of-the-day__product-wrap">
      <div class="product-of-the-day__product-top-line">
        <div class="product-of-the-day__product-wrap-title">
          <div class="product-of-the-day__product-wrap-title-block">{{ $t('product_of_the_day') }} | {{ currentDay }}</div>
          <div class="product-of-the-day__product-wrap-title-timer">
            <div class="product-of-the-day__product-wrap-title-counter">
              {{ $t('time_to_end') }}
            </div>
            <timer
              class="product-countdown__timer"
              @closeTimer="refetchAction"
              is-product-page
              :deadline="deadline"
              type="light"
            />
          </div>
        </div>
      </div>
      <div class="product-of-the-day__product-content">
        <div class="product-of-the-day__product-column">
          <a :href="product.link" class="product-of-the-day__product-title">{{ productTitle }}</a>
          <div class="product-of-the-day__product-price-wrap">
            <div class="product-of-the-day__product-price product-of-the-day__product-price--new">{{ product.price.price_new }} грн</div>
            <div
              class="product-of-the-day__product-price product-of-the-day__product-price--old"
              v-if="product.price.price_old && product.price.price_old !== product.price.price_new">
              {{ product.price.price_old }} грн
            </div>
          </div>
          <div class="tablet-max">
            <div class="product-of-the-day__product-wrap-title-counter">
              {{ $t('time_to_end') }}
            </div>
            <timer
              class="product-countdown__timer"
              @closeTimer="refetchAction"
              is-product-page
              :deadline="deadline"
              type="light"
            />
          </div>
          <Button
            class="vue-button--primary"
            :href="product.link"
          >
            {{ $t('product_show_detail_title') }}
          </Button>
        </div>
        <div class="product-of-the-day__product-column">
          <img :src="product.image_url" :alt="productTitle">
          <div class="product-of-the-day__product-discount" v-if="currentDiscount">
            -{{ currentDiscount }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Timer from '@/components/promo-pages/Timer.vue'
import Button from '@/components/inputs/Button.vue'

export default {
  name: 'ProductOfTheDay',
  components: {
    Timer,
    Button
  },
  data () {
    return {

    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    refetchAction: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isUkLanguage']),
    ...mapState({
      config: state => state.init.config
    }),
    banner () {
      return this.data?.data?.banner
    },
    product () {
      return this.data?.data?.product[0]
    },
    productTitle () {
      return this.product ? this.product[`title${this.isUkLanguage ? '' : '_ru'}`] : ''
    },
    currentDay () {
      const date = new Date()
      return date.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric' })
    },
    deadline () {
      return new Date(new Date().setHours(23, 59, 59, 0)).getTime() / 1000
    },
    currentDiscount () {
      if (this.product) {
        const price_old = parseFloat(this.product.price.price_old)
        const price_new = parseFloat(this.product.price.price_new)
        if (this.config.happy_hours) {
          return this.config.happy_hours.sale_rate
        }
        if (price_old !== price_new) {
          return 100 - Math.round((price_new * 100) / price_old)
        }
        return 0
      } else {
        return 0
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.tablet-max
  display: none
  +mmax($tablet)
    display: flex
    padding: 15px 0
    margin-bottom: 10px
    border-top: 1px solid #E7E7E7
    justify-content: space-between
    align-items: center
.product-of-the-day
  display: flex
  justify-content: space-between
  padding: 0 15px
  +mmax($large--mid)
    flex-direction: column
  &__banner
    &-link
      text-decoration: none
      display: block
      font-size: 0
      picture
        display: block
      img
        width: 100%
    &-wrap
      width: calc(50% - 7.5px)
      border-radius: 5px
      overflow: hidden
      +mmax($large--mid)
        width: 726px
        max-width: 100%
        margin: 0 auto 35px
  &__product
    &-discount
      border-radius: 50%
      background-color: #FF2F00
      position: absolute
      width: 150px
      height: 150px
      right: -30px
      bottom: -60px
      color: #fff
      padding: 28px 0 0 30px
      font-size: 36px
      font-weight: 500
      +mmax($tablet)
        border-radius: 19px
        width: auto
        height: auto
        right: unset
        bottom: 0
        left: 15px
        padding: 5px 13px
        font-size: 18px
    &-title
      color: #333
      font-size: 18px
      font-weight: 500
      line-height: 150%
      display: inline-block
      margin-bottom: 20px
      +mmax($tablet)
        margin-bottom: 10px
    &-price
      &-wrap
        display: flex
        align-items: baseline
        margin-bottom: 15px
      &--new
        color: #FF2F00
        font-size: 32px
        font-weight: 700
        margin-right: 24px
        +mmax($tablet)
          font-size: 30px
      &--old
        color: #909090
        font-size: 20px
        text-decoration: line-through
        +mmax($tablet)
          font-size: 18px
    &-content
      border: 1px solid #E7E7E7
      border-top: none
      border-bottom-left-radius: 5px
      border-bottom-right-radius: 5px
      flex-grow: 1
      display: flex
      +mmax($tablet)
        flex-direction: column
    &-column
      width: 50%
      &:last-child
        position: relative
        padding: 0 35px
        display: flex
        align-items: center
        justify-content: center
        +mmax($large--mid)
          width: 55%
          justify-content: flex-start
        +mmax($tablet)
          width: 100%
          justify-content: center
          order: -1
          padding: 0 30px
      &:first-child
        padding: 10px 35px
        display: flex
        flex-direction: column
        justify-content: center
        align-items: flex-start
        +mmax($large--mid)
          width: 45%
        +mmax($tablet)
          width: 100%
          padding: 19px 15px 15px
    &-wrap
      width: calc(50% - 7.5px)
      border-radius: 5px
      overflow: hidden
      display: flex
      flex-direction: column
      +mmax($large--mid)
        width: 100%
      &-title
        background-color: #333
        display: flex
        align-items: center
        justify-content: space-between
        +mmax($tablet)
          justify-content: center
        &-block
          color: #FFF
          font-size: 20px
          font-weight: 500
          text-transform: uppercase
          padding: 17px 25px
        &-timer
          display: flex
          align-items: center
          +mmax($tablet)
            display: none
        &-counter
          color: #FFF
          font-size: 18px
          font-weight: 500
          padding: 17px 25px
          +mmax($tablet)
            padding: 0 10px 0 0
            color: #333
</style>
<style lang="sass">
.product-of-the-day__product-wrap-title-timer .timer--product .timer__wrap
  margin: 5px 7px 5px 0
.product-of-the-day__product-wrap-title-timer .timer--product .timer__container--product
  background-color: #fff
.tablet-max .timer--product .timer__wrap
  margin: 0
.product-of-the-day__product-column .vue-button
  +mmax($tablet)
    width: 100%
    text-align: center
</style>
